module.exports = __webpack_public_path__ + "static/img/partner7.91bcc7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner7.png
// module id = //G1
// module chunks = 8